import { useRef, PropsWithChildren } from 'react';

import InfiniteScroll from '../../InfiniteScroller';
import Masonry from '../Masonry';
import { MasonryProps } from '../Masonry/types';

import { usePagination } from './hooks';

export type VirtualListProps<T> = MasonryProps & {
  list: T[];
  itemPerPage: number;
  presetPagesCount: number;
  renderItem: (props: T) => JSX.Element;
  loader?: JSX.Element;
};

const VirtualList = <T extends {}>({
  list,
  loader,
  className,
  itemPerPage,
  breakpointCols,
  presetPagesCount,
  renderItem
}: PropsWithChildren<VirtualListProps<T>>) => {
  const currentPageNumberRef = useRef(presetPagesCount);
  const { shortList, nextPage, currentPageNumber } = usePagination({
    list,
    limit: itemPerPage,
    preset: currentPageNumberRef.current
  });
  currentPageNumberRef.current = currentPageNumber;

  const hasMoreItems = shortList.length < list.length;

  return (
    <InfiniteScroll
      loader={loader}
      hasMore={hasMoreItems}
      loadMore={nextPage}
      useWindow={true}
      pageStart={3}
      threshold={300}
    >
      <Masonry {...{ className, breakpointCols }}>{shortList.map(renderItem)}</Masonry>
    </InfiniteScroll>
  );
};
export default VirtualList;
